import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

const PlayerHeader = ({ serieTitle, serieUrl, episodeNum, temporada }) => {
  return (
    <div className='flex items-center justify-between bg-white rounded-lg shadow px-5 py-3 mb-3 mt-4'>
      <div>
        {serieTitle ? (
          <>
            <h1 className='text-red-1 font-bold font-montserrat text-xl leading-tight'>{serieTitle}</h1>
            <p className='text-gray-400 text-xs font-montserrat uppercase tracking-wider mt-0.5'>
              Episodio {episodeNum}
              {temporada ? ` · Temporada ${temporada}` : ''}
            </p>
          </>
        ) : (
          <>
            <div className='h-5 w-48 bg-gray-200 animate-pulse rounded mb-1' />
            <div className='h-3 w-24 bg-gray-100 animate-pulse rounded' />
          </>
        )}
      </div>
      <Link
        to={`/series/${serieUrl}`}
        className='flex items-center gap-2 bg-red-1 hover:bg-darkred text-white text-sm font-montserrat font-semibold px-4 py-2 rounded-lg transition-colors flex-shrink-0'
      >
        <FontAwesomeIcon icon={faArrowLeft} />
        <span>Volver</span>
      </Link>
    </div>
  );
};

export default PlayerHeader;
